export const ERROR = 'post/ERROR';
export const POST_LIST = 'post/POST_LIST';
export const FLUSH = 'FLUSH';
export const LOGOUT = 'post/LOGOUT';
export const MESSAGE = 'post/MESSAGE';
export const POST_DETAILS = 'post/POST_DETAILS';
export const POST_COMMENTS = 'post/POST_COMMENTS';
export const POST_LIKES = 'post/POST_LIKES';